import React, { useState, useEffect } from 'react';
import { resendVerificationEmail, checkVerificationStatus } from '../api/api';
import '../pages/Auth.css';

function VerificationBanner() {
  const [emailVerified, setEmailVerified] = useState(true);
  const [resending, setResending] = useState(false);
  const [resendSuccess, setResendSuccess] = useState(false);
  const [error, setError] = useState('');
  
  const userEmail = localStorage.getItem('userEmail');

  useEffect(() => {
    const checkStatus = async () => {
      if (!userEmail) return;
      
      try {
        const response = await checkVerificationStatus(userEmail);
        setEmailVerified(response.data.email_verified);
      } catch (err) {
        // If check fails, assume verified to not block the user
        console.log('Could not check verification status');
      }
    };

    checkStatus();
  }, [userEmail]);

  const handleResend = async () => {
    if (!userEmail) return;
    
    setResending(true);
    setError('');
    setResendSuccess(false);

    try {
      await resendVerificationEmail(userEmail);
      setResendSuccess(true);
      setTimeout(() => setResendSuccess(false), 5000);
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to resend verification email');
      setTimeout(() => setError(''), 5000);
    } finally {
      setResending(false);
    }
  };

  // Don't show banner if email is verified
  if (emailVerified) {
    return null;
  }

  return (
    <div className="verification-banner">
      <div className="verification-banner-content">
        <span className="verification-banner-icon">📧</span>
        <div className="verification-banner-text">
          <h4>Verify Your Email</h4>
          <p>
            {resendSuccess 
              ? 'Verification email sent! Check your inbox.' 
              : error 
                ? error 
                : 'Please verify your email to access all features.'}
          </p>
        </div>
      </div>
      <div className="verification-banner-action">
        <button 
          className="verification-banner-btn" 
          onClick={handleResend}
          disabled={resending || resendSuccess}
        >
          {resending ? 'Sending...' : resendSuccess ? 'Sent!' : 'Resend Email'}
        </button>
      </div>
    </div>
  );
}

export default VerificationBanner;
